import { Flex, Loader, Title } from "@mantine/core";
import Header from "components/layouts/Header";

const Redirecting = () => {
  return (
    <>
      <Header isEmptyNav={true} />
      <Flex justify="center" align="center" direction="column" h="100vh">
        <Loader color="blue" size="100px" />
        <Title order={3} maw="400px" ta="center" mt="xl">
          Please wait while we set up your profile
        </Title>
      </Flex>
    </>
  );
};

export default Redirecting;
